import CorporateCareTypeSelection from '@/apps/corporate_onboarding/CorporateCareTypeSelection.vue';
import { requireSeeker } from '../guards/authGuards';
import corporateOnboardingSegmentGuard from '../guards/corporateOnboardingSegmentGuard';
import combineGuards from '../guards/helpers';

/**
 * Corporate Onboarding Routes
 *
 * Routes for corporate users to complete their onboarding process.
 * Currently consists of a single step: care type selection.
 */
const corporateOnboardingRoutes = [
  {
    path: '/corporate-onboarding',
    redirect: '/corporate-onboarding/care-type',
  },
  {
    path: '/corporate-onboarding/care-type',
    name: 'corporate_onboarding_care_type',
    component: CorporateCareTypeSelection,
    meta: { simpleHeader: true },
    beforeEnter: combineGuards([requireSeeker, corporateOnboardingSegmentGuard]),
  },
];

export default corporateOnboardingRoutes;
